import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { DynamicFormsV2Component } from '../../shared/dynamic-forms-v2/dynamic-forms-v2.component';

@Component({
  selector: 'app-resume-consultation-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, DynamicFormsV2Component],
  template: `
    <h2 mat-dialog-title>Resume Consultation</h2>
    <mat-dialog-content>
      <div style="background-color: var(--mat-sys-primary-container); color: var(--mat-sys-on-primary-container); padding: 12px; border-radius: 8px; margin-bottom: 16px;">
        <strong>Note:</strong> You ({{currentUserName}}) will be automatically added to this encounter.
      </div>
      <p class="mb-4">Select any <strong>additional</strong> practitioners who are joining this consultation.</p>
      <app-dynamic-forms-v2 #actorsDF [formFields]="actorsFormFields"></app-dynamic-forms-v2>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="cancel()">Cancel</button>
      <button mat-flat-button color="primary" (click)="submit()">Start Consultation</button>
    </mat-dialog-actions>
  `
})
export class ResumeConsultationDialogComponent implements OnInit {
  dialogRef = inject(MatDialogRef<ResumeConsultationDialogComponent>);
  data = inject(MAT_DIALOG_DATA);

  @ViewChild('actorsDF') actorsDF!: DynamicFormsV2Component;
  actorsFormFields: any[] = [];
  currentUserName: string = '';

  ngOnInit() {
    this.actorsFormFields = this.data.actorsFormFields || [];
    this.currentUserName = this.data.currentUserName || 'Current User';
  }

  cancel() {
    this.dialogRef.close(null);
  }

  submit() {
    // If they didn't fill anything out, that's fine, we still add the current user.
    let val = null;
    if (this.actorsDF && this.actorsDF.aForm) {
      if (this.actorsDF.aForm.invalid) {
        this.actorsDF.aForm.markAllAsTouched();
        return;
      }
      val = this.actorsDF.aForm.value;
    }
    
    this.dialogRef.close(val || {});
  }
}
